import { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useNavigate, useLocation } from 'react-router-dom';
import FeedbackModal from './FeedbackModal';

const HelpDropdown = () => {
  const [dropdown, setDropDown] = useState(null);
  const [openFeedbackModal,setOpenFeedbackModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const basePath = location.pathname.split("/")[1]; 

  const handleClick = (e) => {
    setDropDown(e.currentTarget);
  };
  
  const handleClose = () => {
    setDropDown(null);
  };
  
  const handleSelect = (type) => {
    setDropDown(null);
    if (type === "feedback") {
      setOpenFeedbackModal(true);
    } else {
      setOpenFeedbackModal(false);

      navigate(`/${basePath}/help?section=${type}`);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<HelpOutlineIcon />}
        onClick={handleClick}
        sx={{
          borderColor: '#1976d2',
          color: '#1976d2',
          textTransform: 'none',
          borderRadius: '8px',
          '&:hover': {
            borderColor: '#1565c0',
            backgroundColor: '#e3f2fd',
          },
        }}
      >
        Help
      </Button>

      <Menu
        anchorEl={dropdown}
        open={dropdown}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { mt: 0.5 },
        }}
      >
        <MenuItem onClick={() => handleSelect("feedback")}>Feedback</MenuItem>
        <MenuItem onClick={() => handleSelect("release-notes")}>Release Notes</MenuItem>
        <MenuItem onClick={() => handleSelect("faq")}>FAQ's</MenuItem>
        <MenuItem onClick={() => handleSelect("tutorial")}>Tutorial</MenuItem>
      </Menu>

      <FeedbackModal open={openFeedbackModal} setOpen={setOpenFeedbackModal}/>
    </>
  );
};

export default HelpDropdown;
